export enum CardDataType {
    Channel = 1,
    Guide = 2,
}
